import React from "react";
import schedule from "../schedule.json";
import bg from "../images/scaimage3.jpeg";

const SchedulePage = () => {
  return (
    <div className="min-h-screen">
      <div
        className="min-h-screen bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `linear-gradient(
            rgba(10, 30, 50, 0.76),
            rgba(10, 30, 50, 0.76)
          ), url(${bg})`,
        }}
      >
        <div className="px-4 py-10">
          <main className="mx-auto max-w-5xl rounded-2xl bg-white/95 p-6 shadow-2xl backdrop-blur-sm sm:p-9">
            <header className="mx-auto max-w-3xl text-center">
              <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-[#9d4a3f]">
                Giving back together
              </p>

              <h1 className="mt-3 text-3xl font-extrabold leading-tight text-gray-950 sm:text-5xl">
                {schedule.title}
              </h1>

              <p className="mt-4 text-lg font-bold text-sky-950 sm:text-xl">
                {schedule.timeframe}
              </p>

              <p className="mx-auto mt-3 max-w-2xl leading-7 text-gray-700">
                {schedule.status} Check the sign-up sheet for the latest opportunities, dates, and availability.
              </p>

              <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href={schedule.signupUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex rounded-full bg-[#9d4a3f] px-6 py-3 text-sm font-bold text-white shadow-md transition hover:bg-[#843d34]"
                >
                  Open the 2026 Sign-Up Sheet
                </a>

                <span className="rounded-full bg-sky-100 px-5 py-3 text-sm font-bold text-sky-950">
                  Goal: {schedule.goal}
                </span>
              </div>
            </header>

            <section className="mt-10" aria-labelledby="hub-heading">
              <div className="border-b border-gray-200 pb-4">
                <h2 id="hub-heading" className="text-2xl font-extrabold text-gray-950 sm:text-3xl">
                  Volunteer hubs and captains
                </h2>
                <p className="mt-2 text-gray-700">
                  These teams are planning local, national, and virtual service opportunities. Specific event details will be added as they are confirmed.
                </p>
              </div>

              <div className="mt-6 grid gap-5 md:grid-cols-2">
                {schedule.hubs.map((hub) => (
                  <article key={hub.id} className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                    <h3 className="text-xl font-extrabold text-sky-950">{hub.area}</h3>

                    <div className="mt-4">
                      <h4 className="text-xs font-extrabold uppercase tracking-wider text-[#9d4a3f]">
                        Volunteer {hub.captains.length === 1 ? "captain" : "captains"}
                      </h4>
                      <p className="mt-1 leading-7 text-gray-800">{hub.captains.join(" · ")}</p>
                    </div>

                    <div className="mt-4">
                      <h4 className="text-xs font-extrabold uppercase tracking-wider text-gray-500">
                        Opportunities under consideration
                      </h4>
                      {hub.ideas.length ? (
                        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-6 text-gray-700">
                          {hub.ideas.map((idea) => <li key={idea}>{idea}</li>)}
                        </ul>
                      ) : (
                        <p className="mt-2 text-sm italic text-gray-500">Planning in progress</p>
                      )}
                    </div>
                  </article>
                ))}
              </div>
            </section>

            <section className="mt-8 rounded-xl border border-sky-100 bg-sky-50 p-5" aria-labelledby="developing-heading">
              <h2 id="developing-heading" className="text-xl font-extrabold text-sky-950">
                Additional metro clusters
              </h2>
              <p className="mt-2 text-sm leading-6 text-gray-700">
                Planning is also developing for {schedule.developingAreas.join(", ")}. Captain and event details are still to come.
              </p>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SchedulePage;
